import React, { PureComponent } from 'react'
import { Text } from '../../Atoms/Typography'
import { getValueChangeColour, formatValueChange } from '../../../lib/formatters'

class ValueChangeText extends PureComponent {
  render () {
    const { dp = 2, value, isCost, changeUnit, dashIfZero, largeThreshold, removePlusSign, negativeInBrackets, ...otherProps } = this.props
    let valueChange = ''
    if (value === Number.MAX_SAFE_INTEGER || (largeThreshold && Math.abs(value) > largeThreshold)) {
      valueChange = 'LARGE'
    } else {
      valueChange = formatValueChange(value, changeUnit, dashIfZero, dp)
      if (removePlusSign) {
        valueChange = valueChange.replace('+', '')
      }
      if (negativeInBrackets && value < 0) {
        valueChange = `(${valueChange.replace('-', '')})`
      }
    }
    const colour = valueChange === '-' ? 'black' : getValueChangeColour(value, isCost)
    return (
      <Text colour={colour} {...otherProps}>{valueChange}</Text>
    )
  }
}

export default ValueChangeText
